<template>
  <div class="row">
    <!--  用户列表  -->
    <div class="flex xs12">
      <va-card title="用户">
        <div class="row align--start mb-1">
          <div class="flex md12 xs12">
            <va-button-group>
              <va-button class="mb-2" flat disabled color="gray">用户类型：</va-button>
              <va-button class="mb-2" flat :color="computedColor(null)" v-on:click="handleUserTypeChange(null)" >全部</va-button>
              <va-button
                class="mb-2"
                flat
                :color="computedColor(t.CODE)"
                v-on:click="handleUserTypeChange(t.CODE)"
                v-for="t in userTypes"
                :key="t.CODE"
              >{{t.TEXT}}</va-button>
            </va-button-group>
          </div>
          <div class="flex md6 xs12 sm6">
            <va-input
              class="ma-0"
              :value="nickname"
              placeholder="搜索用户昵称"
              @input="search"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex md6 xs12 sm6">
            <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="users"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listUser"
          api-mode
        >
          <template slot="avatar" slot-scope="props">
            <img :src="props.rowData.avatar" class="data-table-server-pagination---avatar" alt="avatar">
          </template>

          <template slot="userType" slot-scope="props">
            <va-badge :color=computeUserTypeColor(props.rowData.userType).color>
              {{ computeUserTypeColor(props.rowData.userType).text }}
            </va-badge>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="查看" placement="top">
              <va-button flat small color="gray" icon="fa fa-eye"
                :to='{path:`updateUser/${props.rowData.uid}`}'/>
            </va-popover>
            <va-popover message="评论权限" placement="top">
              <va-button flat small :color="props.rowData.commentPermission ? 'info' : 'gray'" icon="va-icon vuestic-iconset vuestic-iconset-comments"
                @click="props.rowData.commentPermission ? deleteCommentPermissionModal=true : assignCommentPermissionModal=true;commentPermissionUserNickname=props.rowData.nickname;commentPermissionUserUid=props.rowData.uid"/>
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash" :disabled="props.rowData.uid === libaTeacherUid"
                @click="deleteModal = true;deleteUid=props.rowData.uid"/>
            </va-popover>
          </template>
        </va-data-table>
        <va-modal
          v-model="deleteModal"
          title="删除篱笆预告"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />
        <va-modal
          v-model="assignCommentPermissionModal"
          :title="'给' + commentPermissionUserNickname + '给予评论权限'"
          okText="提交"
          position="center"
          message="请再次确认是否要给予评论权限？"
          @ok="confirmAssignCommentPermission"
        />
        <va-modal
          v-model="deleteCommentPermissionModal"
          :title="'取消' + commentPermissionUserNickname + '评论权限'"
          okText="提交"
          position="center"
          message="请再次确认是否要取消评论权限？"
          @ok="confirmDeleteCommentPermission"
        />
      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import userApi from '../../api/user'
import { USER_TYPES } from '@/utils/constants'
import commentPermissionApi from '@/api/commentPermission'
import { formatTime } from '@/utils/common'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      users: [],
      nickname: null,
      loading: true,
      pageNumber: 1,
      pageSize: 10,
      totalCount: 0,
      totalPages: 1,
      userType: null,
      userTypes: USER_TYPES,
      deleteModal: false,
      assignCommentPermissionModal: false,
      deleteCommentPermissionModal: false,
      commentPermissionUserNickname: '',
      commentPermissionUserUid: '',
      deleteUid: null,
      libaTeacherUid: '',
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:avatar',
          title: '头像',
          width: '60px',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'nickname',
          title: '用户名字',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'uid',
          title: 'uid',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:userType',
          title: '用户类型',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listUser()
    this.libaTeacherUid = process.env.VUE_APP_SERVER_LIBA_TEACHER_UID+''
    console.log(this.libaTeacherUid === '265683179747201698')
  },
  methods: {
    listUser (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        userType: this.userType,
        name: this.nickname,
      }
      userApi.listUser(params).then(response => {
        this.users = response.users
        this.users.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
        this.totalPages = response.pages.totalPage
        this.pageNumber = pageNumber
        this.totalCount = response.pages.totalCount
        this.loading = false
      }).catch(error => alert(error))
    },
    handleUserTypeChange (userType) {
      this.userType = userType
      this.listUser()
    },
    search: debounce(function (nickname) {
      this.nickname = nickname
      if (this.nickname === '') { this.nickname = null }
      this.listUser()
    }, 400),
    computedColor: function (userType) {
      return this.userType === userType ? 'info' : 'gray'
    },
    computeUserTypeColor: function (userType) {
      const data = {
        color: 'info',
        text: '全部',
      }
      USER_TYPES.map(x => {
        if (userType === x.CODE) {
          data.text = x.TEXT
        }
      })
      return data
    },
    confirmDelete () {
      if (this.deleteUid === null) return
      userApi.deleteUser(this.deleteUid).then(response => {
        if (response.success === true) {
          this.showToast('删除用户成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listUser()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    confirmAssignCommentPermission () {
      if (this.commentPermissionUserUid === null || this.commentPermissionUserUid === '') return
      const params = {
        userUid: this.commentPermissionUserUid,
      }
      commentPermissionApi.saveCommentPermission(params).then(response => {
        if (response.success === true) {
          this.showToast('给予评论权限成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listUser()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    confirmDeleteCommentPermission () {
      if (this.commentPermissionUserUid === null || this.commentPermissionUserUid === '') return
      commentPermissionApi.deleteCommentPermission(this.commentPermissionUserUid).then(response => {
        if (response.success === true) {
          this.showToast('取消评论权限成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listUser()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    }
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
